import React, { useState, useEffect } from "react";
import { X, Lightbulb, CheckCircle2 } from "lucide-react";

const sdgs = [
  { 
    id: 1, 
    title: "No Poverty", 
    color: "#e5243b", 
    description: "End poverty in all its forms everywhere.", 
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_01NoPoverty.svg.png",
    facts: ["xxxxxx", "xxxxxx", "xxxxxx"],
    actions: ["xxxxxx", "xxxxxx", "xxxxxx"]
  },
  { id: 2, title: "Zero Hunger", color: "#dda63a", description: "End hunger, achieve food security and improved nutrition.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_02ZeroHunger.svg.png", facts: [], actions: [] },
  { id: 3, title: "Good Health", color: "#4c9f38", description: "Ensure healthy lives and promote well-being for all at all ages.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_03GoodHealth.svg.png", facts: [], actions: [] },
  { id: 4, title: "Quality Education", color: "#c5192d", description: "Ensure inclusive and equitable quality education.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_04QualityEducation.svg.png", facts: [], actions: [] },
  { id: 5, title: "Gender Equality", color: "#ff3a21", description: "Achieve gender equality and empower all women and girls.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_05GenderEquality.svg.png", facts: [], actions: [] },
  { id: 6, title: "Clean Water", color: "#26bde2", description: "Ensure availability and sustainable management of water.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_06CleanWaterSanitation.svg.png", facts: [], actions: [] },
  { id: 7, title: "Affordable Energy", color: "#fcc30b", description: "Ensure access to affordable, reliable, sustainable energy.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_07CleanEnergy.svg.png", facts: [], actions: [] },
  { id: 8, title: "Decent Work", color: "#a21942", description: "Promote sustained, inclusive and sustainable economic growth.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_08DecentWork.svg.png", facts: [], actions: [] },
  { id: 9, title: "Industry & Innovation", color: "#fd6925", description: "Build resilient infrastructure and foster innovation.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_09Industry.svg.png", facts: [], actions: [] },
  { id: 10, title: "Reduced Inequality", color: "#dd1367", description: "Reduce inequality within and among countries.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_10ReducedInequalities.svg.png", facts: [], actions: [] },
  { id: 11, title: "Sustainable Cities", color: "#fd9d24", description: "Make cities and human settlements inclusive and safe.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_11SustainableCities.svg.png", facts: [], actions: [] },
  { id: 12, title: "Responsible Consumption", color: "#bf8b2e", description: "Ensure sustainable consumption and production patterns.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_12ResponsibleConsumption.svg.png", facts: [], actions: [] },
  { id: 13, title: "Climate Action", color: "#3f7e44", description: "Take urgent action to combat climate change and its impacts.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_13Climate.svg.png", facts: [], actions: [] },
  { id: 14, title: "Life Below Water", color: "#0a97d9", description: "Conserve and sustainably use the oceans and seas.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_14LifeBelowWater.svg.png", facts: [], actions: [] },
  { id: 15, title: "Life on Land", color: "#56c02b", description: "Protect, restore and promote sustainable use of ecosystems.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_15LifeOnLand.svg.png", facts: [], actions: [] },
  { id: 16, title: "Peace & Justice", color: "#00689d", description: "Promote peaceful and inclusive societies.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_16PeaceJusticeInstitutions.svg.png", facts: [], actions: [] },
  { id: 17, title: "Partnerships", color: "#19486a", description: "Strengthen the means of implementation for the SDGs.", imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_17Partnerships.svg.png", facts: [], actions: [] },
];

export default function SDGs() {
  const [selectedSDG, setSelectedSDG] = useState(null);

  // --- NAVBAR TRIGGER ---
  useEffect(() => {
    const navElement = document.querySelector("nav");
    if (navElement) {
      navElement.style.display = selectedSDG ? "none" : "flex";
    }
    return () => { if (navElement) navElement.style.display = "flex"; };
  }, [selectedSDG]);

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#FFFFFF",
      padding: "1.5rem 1rem 120px 1rem",
      fontFamily: "'Inter', sans-serif",
      color: "#2D302D",
    },
    header: {
      fontSize: "2rem",
      fontWeight: "900",
      textAlign: "center",
      marginTop: "1rem",
      marginBottom: "0.5rem",
      letterSpacing: "-1px",
      background: "linear-gradient(135deg, #2D302D 0%, #12873B 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    subHeader: {
      textAlign: "center",
      color: "#94A3B8",
      fontSize: "0.85rem",
      marginBottom: "2rem",
      fontWeight: "500"
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "12px",
      maxWidth: "500px", 
      margin: "0 auto",
    },
    sdgCard: (color) => ({
      aspectRatio: "1/1",
      borderRadius: "28px",
      padding: "8px", 
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      backgroundColor: `${color}15`, 
      border: `1px solid ${color}10`,
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    }),
    cardImage: {
      width: "100%", 
      height: "100%",
      objectFit: "cover",
      borderRadius: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
    },
    modalOverlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(12px)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem"
    },
    modalContent: {
      backgroundColor: "#FFFFFF",
      width: "100%",
      maxWidth: "380px",
      maxHeight: "90vh",
      overflowY: "auto",
      borderRadius: "40px",
      padding: "2.5rem 1.5rem",
      position: "relative",
      boxShadow: "0 25px 50px -12px rgba(0,0,0,0.3)",
      scrollbarWidth: "none",
    },
    sectionTitle: (color) => ({
      fontSize: "1.1rem",
      fontWeight: "800",
      color: color,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "1.5rem",
      marginBottom: "0.8rem",
      textAlign: "left"
    }),
    infoCard: (color) => ({
      backgroundColor: `${color}08`,
      padding: "0.8rem",
      borderRadius: "16px",
      marginBottom: "0.6rem",
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      border: `1px solid ${color}10`,
      textAlign: "left"
    })
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>The UN Sustainable Development Goals</h1>
      <p style={styles.subHeader}>17 Goals to Transform Our World</p>

      <div style={styles.grid}>
        {sdgs.map((sdg) => (
          <div 
            key={sdg.id} 
            style={styles.sdgCard(sdg.color)}
            onClick={() => setSelectedSDG(sdg)}
          >
            <img src={sdg.imageUrl} alt={sdg.title} style={styles.cardImage} />
          </div>
        ))}
      </div>

      {selectedSDG && (
        <div style={styles.modalOverlay} onClick={() => setSelectedSDG(null)}>
          <div className="modal-scroll-area" style={styles.modalContent} onClick={e => e.stopPropagation()}>
            <button 
                onClick={() => setSelectedSDG(null)}
                style={{ position: "absolute", top: "1.2rem", right: "1.2rem", background: "#F7F9F7", border: "none", borderRadius: "50%", padding: "8px", cursor: "pointer", zIndex: 10 }}
            >
                <X size={20} color="#94A3B8" />
            </button>

            <div style={{ textAlign: "center" }}>
              <div style={{ width: "100px", height: "100px", margin: "0 auto 1rem auto", borderRadius: "20px", backgroundColor: `${selectedSDG.color}15`, padding: "8px" }}>
                  <img src={selectedSDG.imageUrl} alt={selectedSDG.title} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "14px" }} />
              </div>

              <h2 style={{ margin: 0, fontWeight: "900", fontSize: "1.5rem", color: selectedSDG.color }}>
                  {selectedSDG.title}
              </h2>
              
              <p style={{ color: "#4A5568", lineHeight: "1.5", fontSize: "0.9rem", margin: "1rem 0" }}>
                  {selectedSDG.description}
              </p>
            </div>

            {/* FACTS SECTION */}
            <h3 style={styles.sectionTitle(selectedSDG.color)}>
              <Lightbulb size={18} /> Key Facts
            </h3>
            {selectedSDG.facts && selectedSDG.facts.length > 0 ? (
              selectedSDG.facts.map((fact, i) => (
                <div key={i} style={styles.infoCard(selectedSDG.color)}>
                  <span style={{ color: selectedSDG.color, fontWeight: "bold" }}>•</span>
                  <p style={{ margin: 0, fontSize: "0.85rem", color: "#2D302D" }}>{fact}</p>
                </div>
              ))
            ) : (
              <p style={{ fontSize: "0.8rem", color: "#94A3B8", fontStyle: "italic", textAlign: "left" }}>Coming soon</p>
            )}

            {/* ACTIONS SECTION */}
            <h3 style={styles.sectionTitle(selectedSDG.color)}>
              <CheckCircle2 size={18} /> Take Action
            </h3>
            {selectedSDG.actions && selectedSDG.actions.length > 0 ? (
              selectedSDG.actions.map((action, i) => (
                <div key={i} style={styles.infoCard(selectedSDG.color)}>
                  <CheckCircle2 size={14} color={selectedSDG.color} style={{ flexShrink: 0, marginTop: "2px" }} />
                  <p style={{ margin: 0, fontSize: "0.85rem", color: "#2D302D" }}>{action}</p>
                </div>
              ))
            ) : (
              <p style={{ fontSize: "0.8rem", color: "#94A3B8", fontStyle: "italic", textAlign: "left" }}>Coming soon</p>
            )}

            <button 
                onClick={() => setSelectedSDG(null)} 
                style={{ 
                    width: "100%", 
                    padding: "1rem", 
                    borderRadius: "20px", 
                    border: "none", 
                    background: "linear-gradient(135deg, #2D302D 0%, #12873B 100%)", 
                    color: "white", 
                    fontWeight: "700", 
                    marginTop: "1.5rem",
                    cursor: "pointer"
                }}
            >
                Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}